import { useDisclosureCoverage } from '@/hooks/useDisclosureCoverage';
import { cn } from '@/lib/utils';

export function DisclosureStatusBadge() {
  const { overallCompleteness, isLoading } = useDisclosureCoverage();

  if (isLoading) return null;

  const color =
    overallCompleteness >= 90
      ? 'bg-green-500'
      : overallCompleteness >= 50
        ? 'bg-yellow-500'
        : 'bg-red-500';

  return (
    <span
      className={cn('inline-block h-2.5 w-2.5 rounded-full', color)}
      data-testid="disclosure-status-badge"
    />
  );
}

export default DisclosureStatusBadge;
